import {
  createContext,
  useContext,
  useEffect,
  useState
} from "react";

interface Permission {
  action: string;
}

// Crie um contexto para as permissões
const PermissionContext = createContext<Permission[] | undefined>(undefined);

// Hook para usar o contexto
export const usePermissions = (action: string) => {
  const permissions = useContext(PermissionContext);

  if (!permissions) {
    throw new Error("usePermissions must be used within a PermissionProvider");
  }

  const storedUser = localStorage.getItem("user") || localStorage.getItem("user");
  if (storedUser) {
    const user = JSON.parse(storedUser);
    if (user.grupo === "ADMINISTRADOR") {
      return true;
    }
  }

  const paths = window.location.pathname.replace("/", "").split("/");

  let permissionsData: any[] = [];

  const getPermissions = localStorage.getItem("permissions") || localStorage.getItem("permissions");

  if (getPermissions) {
    permissionsData = JSON.parse(getPermissions);
  }

  const mappingPermissionsData = permissionsData.map((perm) => ({
    action: perm.action,
    subsystem: paths[0].toUpperCase(),
    module: perm.module,
    submodule: perm.submodule,
  }));

  console.log(action.toUpperCase(), paths[0].toUpperCase(), paths[1].toUpperCase(), paths[2].toUpperCase());

  const hasPermission = mappingPermissionsData.some(
    (perm: any) =>
      perm.action === action.toUpperCase() &&
      (perm.module ? perm.module.toLowerCase() === paths[1]?.toLowerCase() : true) &&
      (perm.submodule ? perm.submodule.toLowerCase() === paths[2]?.toLowerCase() : true)
  );

  return hasPermission;
};

// Provider para fornecer as permissões
export const PermissionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [permissions, setPermissions] = useState<Permission[]>([]);

  useEffect(() => {
    const getPermissions = localStorage.getItem("permissions") || localStorage.getItem("permissions");

    if (getPermissions) {
      setPermissions(JSON.parse(getPermissions));
    }
  }, []);

  return (
    <PermissionContext.Provider value={permissions}>
      {children}
    </PermissionContext.Provider>
  );
};
